import { render, staticRenderFns } from "./NavigationMobile.vue?vue&type=template&id=5482968f&scoped=true&"
import script from "./NavigationMobile.vue?vue&type=script&lang=js&"
export * from "./NavigationMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMobile.vue?vue&type=style&index=0&id=5482968f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482968f",
  null
  
)

export default component.exports